import { combineReducers } from "redux";

import home from "./home";
import { HomePageState } from "./home/types";
import requests from "./requests";
import { RequestsState } from "./requests/types";
import snackbar, { SnackbarState } from "./snackbar";
import user from "./user";
import { UserState } from "./user/types";
import collection from "./collection";
import { CollectionState } from "./collection/types";
import consents from "./consents";
import { ConsentState } from "./consents/types";
import appConfiguration from "./appConfiguration";
import { AppConfigurationState } from "./appConfiguration/types";
import annualClock from "./annualClock";
import { AnnualClockState } from "./annualClock/types";
import recommends from "./recommends";
import { RecommendsState } from "./recommends/types";
import recruitmentJourney from "./recruitmentJourney";
import { RecruitmentJourneyState } from "./recruitmentJourney/types";
import { ZendeskKnowledgeState } from "./zendesk/types";
import zendeskKnowledge from "./zendesk";

export interface RootState {
    home: HomePageState;
    requests: RequestsState;
    snackbar: SnackbarState;
    user: UserState;
    collection: CollectionState;
    consents: ConsentState;
    appConfiguration: AppConfigurationState;
    annualClock: AnnualClockState;
    recommends: RecommendsState;
    recruitmentJourney: RecruitmentJourneyState;
    zendeskKnowledge: ZendeskKnowledgeState;
}

export const createRootReducer = () =>
    combineReducers({
        home,
        requests,
        snackbar,
        user,
        collection,
        consents,
        appConfiguration,
        annualClock,
        recommends,
        recruitmentJourney,
        zendeskKnowledge,
    });
